import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import Layout from './components/Layout/Layout';
import Backdrop from './components/Backdrop/Backdrop';
import Toolbar from './components/Toolbar/Toolbar';
import MainNavigation from './components/Navigation/MainNavigation/MainNavigation';
import MobileNavigation from './components/Navigation/MobileNavigation/MobileNavigation';
import ErrorHandler from './components/ErrorHandler/ErrorHandler';
import OrderPage from './pages/Feed/OrderList';
import SingleOrderPage from './pages/Feed/SingleOrder/SingleOrder';
import SinglePostPage from './pages/Feed/SinglePost/SinglePost';
import CategoryPage from "./pages/Category/Category";
import BrandPage from "./pages/Brand/Brand";
import ColorPage from "./pages/Color/Color";
import SizePage from "./pages/Size/Size";
import WarrantyPage from "./pages/Warranty/Warranty";
import AddProductPage from "./pages/Product/Product";
import EditProductPage from "./pages/Product/EditProduct/EditProduct";
import CreateVariantPage from "./pages/Variant/CreateVariant";
import ProductsPage from "./pages/ProductList/ProductList";
import Classification from "./pages/Classification/Classification";
import Attribute from "./pages/Attribute/Attribute";
import LoginPage from './pages/Auth/Login';
import LoginTest from './pages/Auth/Test3';
import CreateVariant from './pages/Variant/CreateVariant';
import SignupPage from './pages/Auth/Signup';
import './App.css';

class App extends Component {
  state = {
    showBackdrop: false,
    showMobileNav: false,
    isAuth: false,
    token: null,
    userId: null,
    authLoading: false,
    error: null
  };

  componentDidMount() {
    const token = localStorage.getItem('token');
    const expiryDate = localStorage.getItem('expiryDate');
    if (!token || !expiryDate) {
      return;
    }
    if (new Date(expiryDate) <= new Date()) {
      this.logoutHandler();
      return;
    }
    const userId = localStorage.getItem('userId');
    const remainingMilliseconds =
      new Date(expiryDate).getTime() - new Date().getTime();
    this.setState({ isAuth: true, token: token, userId: userId });
    this.setAutoLogout(remainingMilliseconds);
  }

  mobileNavHandler = isOpen => {
    this.setState({ showMobileNav: isOpen, showBackdrop: isOpen });
  };

  backdropClickHandler = () => {
    this.setState({ showBackdrop: false, showMobileNav: false, error: null });
  };

  logoutHandler = () => {
    this.setState({ isAuth: false, token: null });
    localStorage.removeItem('token');
    localStorage.removeItem('expiryDate');
    localStorage.removeItem('userId');
  };

  loginHandler = (event, authData) => {
    event.preventDefault();
    const graphqlQuery = {
      query: `
        query UserLogin($email: String!, $password: String!) {
          login(email: $email, password: $password) {
            token
            userId
          }
        }
      `,
      variables: {
        email: authData.email,
        password: authData.password
      }
    };
    this.setState({ authLoading: true });
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        console.log(resData);
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error('ورود کاربر ناموفق!');
        }
        this.setState({
          isAuth: true,
          token: resData.data.login.token,
          authLoading: false,
          userId: resData.data.login.userId
        });
        localStorage.setItem('token', resData.data.login.token);
        localStorage.setItem('userId', resData.data.login.userId);
        const remainingMilliseconds = 2 * 60 * 60 * 1000;
        const expiryDate = new Date(
          new Date().getTime() + remainingMilliseconds
        );
        localStorage.setItem('expiryDate', expiryDate.toISOString());
        this.setAutoLogout(remainingMilliseconds);
      })
      .catch(err => {
        console.log(err);
        this.setState({
          isAuth: false,
          authLoading: false,
          error: err
        });
      });
  };

  signupHandler = (event, authData) => {
    event.preventDefault();
    this.setState({ authLoading: true });
    const graphqlQuery = {
      query: `
        mutation CreateNewUser($email: String!, $name: String!, $password: String!) {
          createUser(userInput: {email: $email, name: $name, password: $password}) {
            id
            email
          }
        }
      `,
      variables: {
        email: authData.signupForm.email.value,
        name: authData.signupForm.name.value,
        password: authData.signupForm.password.value
      }
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        console.log(resData);
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error('ثبت نام کاربر ناموفق!');
        }
        this.setState({ isAuth: false, authLoading: false });
        this.props.history.replace('/');
      })
      .catch(err => {
        console.log(err);
        this.setState({
          isAuth: false,
          authLoading: false,
          error: err
        });
      });
  };

  setAutoLogout = milliseconds => {
    setTimeout(() => {
      this.logoutHandler();
    }, milliseconds);
  };

  errorHandler = () => {
    this.setState({ error: null });
  };

  render() {
    let routes = (
      <Switch>
        <Route
          path="/"
          exact
          render={(props) => (
            <LoginPage
              {...props}
              onLogin={this.loginHandler}
              loading={this.state.authLoading}
            />
          )}
        />
        {/* <Route
          path="/"
          exact
          render={(props) => (
            <LoginTest
              {...props}
              onLogin={this.loginHandler}
              loading={this.state.authLoading}
            />
          )}
        /> */}
        {/* <Route
          path="/signup"
          exact
          render={(props) => (
            <SignupPage
              {...props}
              onSignup={this.signupHandler}
              loading={this.state.authLoading}
            />
          )}
        /> */}
        <Redirect to="/" />
      </Switch>
    );
    if (this.state.isAuth) {
      routes = (
        <Switch>
          <Route
            path="/"
            exact
            render={(props) => (
              <OrderPage userId={this.state.userId} token={this.state.token} />
            )}
          />
          <Route
            path="/product/edit/:productCode"
            render={(props) => (
              <EditProductPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/product"
            render={(props) => (
              <ProductsPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/category"
            render={(props) => (
              <CategoryPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />          
          <Route
            path="/brand"
            render={(props) => (
              <BrandPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/add-product"
            render={(props) => (
              <AddProductPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/color"
            render={(props) => (
              <ColorPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/warranty"
            render={(props) => (
              <WarrantyPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/size"
            render={(props) => (
              <SizePage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/Classification"
            render={(props) => (
              <Classification
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/Attribute"
            render={(props) => (
              <Attribute
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/create/product/variant/:productCode"
            render={(props) => (
              <CreateVariantPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/order/detail/:orderCode"
            render={(props) => (
              <SingleOrderPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Route
            path="/:postId"
            render={(props) => (
              <SinglePostPage
                {...props}
                userId={this.state.userId}
                token={this.state.token}
              />
            )}
          />
          <Redirect to="/" />
        </Switch>
      );
    }
    return (
      <Fragment>
        {this.state.showBackdrop && (
          <Backdrop onClick={this.backdropClickHandler} />
        )}
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <Layout
          header={
            <Toolbar>
              <MainNavigation
                onOpenMobileNav={this.mobileNavHandler.bind(this, true)}
                onLogout={this.logoutHandler}
                isAuth={this.state.isAuth}
              />
            </Toolbar>
          }
          mobileNav={
            <MobileNavigation
              open={this.state.showMobileNav}
              mobile
              onChooseItem={this.mobileNavHandler.bind(this, false)}
              onLogout={this.logoutHandler}
              isAuth={this.state.isAuth}
            />
          }
        />
        {routes}
      </Fragment>
    );
  }
}

export default withRouter(App);
